// import { Edit2, Eye,  Pause, Play, Save, Trash2, TrendingUp } from "lucide-react";
// import moment from "moment";
// import { useState } from "react";

// import { Link } from "react-router-dom";

// const CampaignListTable = ({ campaigns, onToggleStatus, onDelete, setEditCampaign, setShowModal }) => {
//   const [selectedCampaign, setSelectedCampaign] = useState(null);

//   const getStatusBadge = (status) => {
//     const styles = {
//       active: 'bg-green-100 text-green-800',
//       paused: 'bg-yellow-100 text-yellow-800',
//       draft: 'bg-gray-100 text-gray-800',
//       ended: 'bg-red-100 text-red-800'
//     };
//     return (
//       <span className={`px-3 py-1 rounded-full text-xs font-semibold ${styles[status]}`}>
//         {status?.toUpperCase()}
//       </span>
//     );
//   };

//   const getBoostDisplay = (campaign) => {
//     if (campaign.boostType === 'multiplier') {
//       return `${campaign?.boostValue?.multiplier}x Points`;
//     } else if (campaign?.boostType === 'fixed_extra') {
//       return `+${campaign?.boostValue?.fixedPoints} Points`;
//     } else {
//       return `${campaign?.boostValue?.replacementRate} pts/$`;
//     }
//   };

//   return (
//     <>
//       <div className="bg-white rounded-lg shadow overflow-hidden">
//         <table className="min-w-full divide-y divide-gray-200">
//           <thead className="bg-gray-50">
//             <tr>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Campaign
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Status
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Boost
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Schedule
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Performance
//               </th>
//               <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Badge
//               </th>
//               <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
//                 Actions
//               </th>
//             </tr>
//           </thead>
//           <tbody className="bg-white divide-y divide-gray-200">
//             {campaigns?.map((campaign) => (
//               <tr key={campaign?._id} className="hover:bg-gray-50">
//                 <td className="px-6 py-4">
//                   <div className="text-sm font-medium text-gray-900">
//                     {campaign?.name}
//                   </div>
//                 </td>
//                 <td className="px-6 py-4 whitespace-nowrap">
//                   {getStatusBadge(campaign?.status)}
//                 </td>
//                 <td className="px-6 py-4 whitespace-nowrap">
//                   <div className="flex items-center gap-2 text-sm text-gray-900">
//                     <TrendingUp size={16} className="text-blue-600" />
//                     {getBoostDisplay(campaign)}
//                   </div>
//                 </td>
//                 <td className="px-6 py-4">
//                   <div className="text-sm text-gray-600">
//                     <div>
//                       {moment(campaign?.schedule?.startDate).format("DD/MM/YYYY")}
//                       {/* {new Date(campaign?.schedule?.startDate).toLocaleDateString()} */}
//                       </div>
//                     <div className="text-xs text-gray-400">
//                       to {moment(campaign?.schedule?.endDate).format("DD/MM/YYYY")}
//                       {/* {new Date(campaign?.schedule?.endDate).toLocaleDateString()} */}
//                     </div>
//                   </div>
//                 </td>
//                 <td className="px-6 py-4">
//                   <div className="text-sm">
//                     <div className="text-gray-900 font-semibold">
//                       {campaign?.analytics?.totalOrders} orders
//                     </div>
//                     <div className="text-gray-600 text-xs">
//                       {campaign?.analytics?.totalPointsAwarded.toLocaleString()} pts
//                     </div>
//                     <div className="text-gray-500 text-xs">
//                       ${campaign?.analytics?.revenue.toLocaleString()}
//                     </div>
//                   </div>
//                 </td>
//                 <td className="px-6 py-4 whitespace-nowrap">
//                   {campaign?.badgeText && (
//                     <span className="bg-purple-100 text-purple-800 px-2 py-1 rounded text-xs font-bold">
//                       {campaign?.badgeText}
//                     </span>
//                   )}
//                 </td>

//                 <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
//                   <div className="flex items-center justify-end gap-2">
//                     {(campaign?.status === 'active' || campaign?.status === 'paused') && (
//                       <button
//                         onClick={() => onToggleStatus(campaign._id, campaign.status)}
//                         className={`${
//                           campaign?.status === 'active'
//                             ? 'text-yellow-600 hover:text-yellow-900'
//                             : 'text-green-600 hover:text-green-900'
//                         }`}
//                         title={campaign?.status === 'active' ? 'Pause Campaign' : 'Activate Campaign'}
//                       >
//                         {campaign?.status === 'active' ? <Pause size={18} /> : <Play size={18} />}
//                       </button>
//                     )}

//                     {campaign?.status === 'draft' && (
//                       <button
//                         onClick={() => onToggleStatus(campaign?._id, campaign.status)}
//                         className="text-green-600 hover:text-green-900"
//                         title="Activate Campaign"
//                       >
//                         <Save className="text-blue-500" size={18} />
//                       </button>
//                     )}

//                     {/* <button 
//                       className="text-gray-600 hover:text-gray-900" 
//                       title="View Details"
//                       onClick={() => setSelectedCampaign(campaign)}
//                     >
//                       <Eye size={18} />
//                     </button> */}
// <Link 
//                                             to={`/product-boost/${campaign._id}`} // 👈 Define the path to your new page
//                                             className="text-gray-600 hover:text-gray-900" 
//                                             title="View Details"
//                                         >
//                                             <Eye size={18} />
//                                         </Link>

//                     {campaign?.status !== 'ended' && (
//                       <button 
//                         className="text-blue-600 hover:text-blue-900"
//                         title="Edit Campaign"
//                         onClick={() => {
//                           setEditCampaign(campaign);
//                           setShowModal(true);
//                         }}
//                       >
//                         <Edit2 size={18} />
//                       </button>
//                     )}

//                     <button
//                       onClick={() => onDelete(campaign._id)}
//                       className="text-red-600 hover:text-red-900"
//                       title="Delete Campaign"
//                     >
//                       <Trash2 size={18} />
//                     </button>
//                   </div>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>


//     </>
//   );
// };

// export default CampaignListTable;


import { Edit2, Eye, Pause, Play, Save, Trash2, Calendar, DollarSign } from "lucide-react";
import moment from "moment";
import { useState } from "react";
import { Link } from "react-router-dom";
import useRbac from "../../../../Hooks/useRbac";

const CampaignListTable = ({  page, setPage, totalPages, campaigns, onToggleStatus, onDelete, setEditCampaign, setShowModal }) => {
  const { can } = useRbac();
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [openDropdown, setOpenDropdown] = useState(null);

  const getStatusBadge = (status) => {
    const styles = {
      active: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
      paused: 'bg-amber-50 text-amber-700 border border-amber-200',
      draft: 'bg-slate-50 text-slate-700 border border-slate-200',
      ended: 'bg-rose-50 text-rose-700 border border-rose-200'
    };
    return (
      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-medium ${styles[status]}`}>
        {status?.toUpperCase()}
      </span>
    );
  };

  const getBoostDisplay = (campaign) => {
    if (campaign.boostType === 'multiplier') {
      return {
        value: `${campaign?.boostValue?.multiplier}x`,
        label: 'Multiplier',
        color: 'text-blue-600 bg-blue-50'
      };
    } else if (campaign?.boostType === 'fixed_extra') {
      return {
        value: `+${campaign?.boostValue?.fixedPoints}`,
        label: 'Fixed Points',
        color: 'text-purple-600 bg-purple-50'
      };
    } else {
      return {
        value: `${campaign?.boostValue?.replacementRate}`,
        label: 'pts/$',
        color: 'text-indigo-600 bg-indigo-50'
      };
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th scope="col" className="px-6 py-3.5 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">
                Campaign Name
              </th>
              <th scope="col" className="px-6 py-3.5 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">
                Status
              </th>
              <th scope="col" className="px-6 py-3.5 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">
                Boost Type
              </th>
              <th scope="col" className="px-6 py-3.5 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">
                Duration
              </th>
              <th scope="col" className="px-6 py-3.5 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">
                Performance
              </th>
              <th scope="col" className="px-6 py-3.5 text-left text-xs font-semibold text-gray-900 uppercase tracking-wider">
                Badge
              </th>
              <th scope="col" className="relative px-6 py-3.5">
                <span className="sr-only">Actions</span>
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-100">
            {campaigns?.map((campaign) => {
              const boost = getBoostDisplay(campaign);
              return (
                <tr key={campaign?._id} className="hover:bg-gray-50 transition-colors duration-150">
                  {/* Campaign Name */}
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                  
                      <div className="ml-4">
                        <div className="text-sm font-semibold text-gray-900">
                          {campaign?.name}
                        </div>
                        <div className="text-xs text-gray-500">
                          ID: {campaign?._id?.slice(-8)}
                        </div>
                      </div>
                    </div>
                  </td>

                  {/* Status */}
                  <td className="px-6 py-4 whitespace-nowrap">
                    {getStatusBadge(campaign?.status)}
                  </td>

                  {/* Boost Type */}
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-lg ${boost.color}`}>
                  
                      <div className="flex flex-col">
                        <span className="text-sm font-bold">{boost.value}</span>
                        <span className="text-xs opacity-75">{boost.label}</span>
                      </div>
                    </div>
                  </td>

                  {/* Duration */}
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-start gap-2">
                      <Calendar size={14} className="text-gray-400 mt-0.5" />
                      <div className="text-sm">
                        <div className="text-gray-900 font-medium">
                          {moment(campaign?.schedule?.startDate).format("MMM DD, YYYY")}
                        </div>
                        <div className="text-xs text-gray-500">
                          to {moment(campaign?.schedule?.endDate).format("MMM DD, YYYY")}
                        </div>
                      </div>
                    </div>
                  </td>

                  {/* Performance */}
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="space-y-1">
                      <div className="flex items-center gap-2">
                        <div className="flex items-center gap-1 text-sm font-semibold text-gray-900">
                          <DollarSign size={14} className="text-green-600" />
                          {campaign?.analytics?.revenue?.toLocaleString()}
                        </div>
                      </div>
                      <div className="flex items-center gap-3 text-xs text-gray-600">
                        <span className="flex items-center gap-1">
                          <span className="w-1.5 h-1.5 rounded-full bg-blue-500"></span>
                          {campaign?.analytics?.totalOrders} orders
                        </span>
                        <span className="flex items-center gap-1">
                          <span className="w-1.5 h-1.5 rounded-full bg-purple-500"></span>
                          {campaign?.analytics?.totalPointsAwarded?.toLocaleString()} pts
                        </span>
                      </div>
                    </div>
                  </td>

                  {/* Badge */}
                  <td className="px-6 py-4 whitespace-nowrap">
                    {campaign?.badgeText ? (
                      <span className="inline-flex items-center px-2.5 py-1 rounded-md text-xs font-semibold text-black shadow-sm">
                        {campaign?.badgeText}
                      </span>
                    ) : (
                      <span className="text-xs text-gray-400">—</span>
                    )}
                  </td>

                  {/* Actions */}
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                    <div className="flex items-center justify-end gap-1">
                      {/* Status Toggle */}
                      {can('boost.change_status') && (campaign?.status === 'active' || campaign?.status === 'paused') && (
                        <button
                          onClick={() => onToggleStatus(campaign._id, campaign.status)}
                          className={`p-2 rounded-lg transition-all duration-150 ${
                            campaign?.status === 'active'
                              ? 'text-amber-600 hover:bg-amber-50'
                              : 'text-emerald-600 hover:bg-emerald-50'
                          }`}
                          title={campaign?.status === 'active' ? 'Pause Campaign' : 'Activate Campaign'}
                        >
                          {campaign?.status === 'active' ? <Pause size={16} /> : <Play size={16} />}
                        </button>
                      )}

                      {/* Draft Activate */}
                      {can('boost.change_status') && campaign?.status === 'draft' && (
                        <button
                          onClick={() => onToggleStatus(campaign?._id, campaign.status)}
                          className="p-2 rounded-lg text-blue-600 hover:bg-blue-50 transition-all duration-150"
                          title="Activate Campaign"
                        >
                          <Save size={16} />
                        </button>
                      )}

                      {/* View Details */}
                      <Link 
                        to={`/product-boost/${campaign._id}`}
                        className="p-2 rounded-lg text-gray-600 hover:bg-gray-100 transition-all duration-150" 
                        title="View Details"
                      >
                        <Eye size={16} />
                      </Link>

                      {/* Edit */}
                      {can('boost.update') && campaign?.status !== 'ended' && (
                        <button
                          className="p-2 rounded-lg text-blue-600 hover:bg-blue-50 transition-all duration-150"
                          title="Edit Campaign"
                          onClick={() => {
                            setEditCampaign(campaign);
                            setShowModal(true);
                          }}
                        >
                          <Edit2 size={16} />
                        </button>
                      )}

                      {/* Delete */}
                      {can('boost.delete') && <button
                        onClick={() => onDelete(campaign._id)}
                        className="p-2 rounded-lg text-rose-600 hover:bg-rose-50 transition-all duration-150"
                        title="Delete Campaign"
                      >
                        <Trash2 size={16} />
                      </button>}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div className="flex justify-between items-center mt-4">
  <button
    disabled={page === 1}
    onClick={() => setPage(p => p - 1)}
    className="px-3 py-1 bg-gray-100 rounded disabled:opacity-50"
  >
    Prev
  </button>

  <span className="text-sm text-gray-600">
    Page {page} of {totalPages}
  </span>

  <button
    disabled={page === totalPages}
    onClick={() => setPage(p => p + 1)}
    className="px-3 py-1 bg-gray-100 rounded disabled:opacity-50"
  >
    Next
  </button>
</div>

      </div>

      {/* Empty State */}
      {(!campaigns || campaigns.length === 0) && (
        <div className="text-center py-12">
          
          <h3 className="mt-2 text-sm font-semibold text-gray-900">No campaigns</h3>
          <p className="mt-1 text-sm text-gray-500">Get started by creating a new campaign.</p>
        </div>
      )}
    </div>
  );
};

export default CampaignListTable;